/**
 * Helpers for reasoning about files from their metadata.
 */

export const isImageFile = (contentType?: string | null): boolean =>
    !!contentType && contentType.startsWith('image/');

/**
 * Display name of a file: the original `basename` (which includes the
 * extension, e.g. "test.png"). Falls back to the editable `filename`
 * (which carries no extension) for entries without a basename.
 */
export const getFileDisplayName = (file: {basename?: string | null; filename?: string | null}): string =>
    file.basename || file.filename || '';
